module.exports = __webpack_public_path__ + "static/media/investBtnBg.65e6fd40.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/investBtnBg.png
// module id = 1787
// module chunks = 0 1